import moment from 'moment';

const dateHelper = {
    methods: {
        // Formats a date to a specific format
        formatDate(date, format = 'YYYY-MM-DD') {
            return moment(date).format(format);
        },

        shortDate(date, format = 'MMM, DD') {
            return moment(date).format(format);
        },

        shortYear(date, format = 'YYYY') {
            return moment(date).format(format);
        },

        longDate(date, format = 'DD MMMM, YYYY') {
            return moment(date).format(format);
        },

        // Parses a string into a Moment date object
        parseDate(dateString, format = 'YYYY-MM-DD') {
            return moment(dateString, format);
        },

        // Adds time to a given date
        addTime(date, value, unit = 'days') {
            return moment(date).add(value, unit).toDate();
        },

        // Subtracts time from a given date
        subtractTime(date, value, unit = 'days') {
            return moment(date).subtract(value, unit).toDate();
        },

        // Calculates the difference between two dates in a specific unit
        dateDifference(date1, date2, unit = 'days') {
            return moment(date1).diff(moment(date2), unit);
        },

        // Converts a date to relative time (e.g., "3 days ago")
        toRelativeTime(date) {
            return moment(date).fromNow();
        },

        // Checks if a date is before another date
        isBefore(date1, date2) {
            return moment(date1).isBefore(moment(date2));
        },

        // Checks if a date is after another date
        isAfter(date1, date2) {
            return moment(date1).isAfter(moment(date2));
        },

        // Checks if a date is the same as another date
        isSame(date1, date2, unit = 'day') {
            return moment(date1).isSame(moment(date2), unit);
        },

        // Returns the start of a given period (e.g., day, month, year)
        startOf(date, unit = 'day') {
            return moment(date).startOf(unit).toDate();
        },

        // Returns the end of a given period (e.g., day, month, year)
        endOf(date, unit = 'day') {
            return moment(date).endOf(unit).toDate();
        },

        // Gets the current date and time
        getNow() {
            return moment().toDate();
        },

        // Converts a date to UTC format
        toUTC(date) {
            return moment(date).utc().format();
        },

        // Converts a UTC date to local time
        toLocal(date) {
            return moment.utc(date).local().format();
        },

        // Validates if a string is a valid date
        isValidDate(dateString, format = 'YYYY-MM-DD') {
            return moment(dateString, format, true).isValid();
        },

        // Gets the day of the week from a date
        getDayOfWeek(date) {
            return moment(date).format('dddd'); // e.g., "Monday"
        },

        // Gets the ISO week number of the year
        getWeekOfYear(date) {
            return moment(date).isoWeek();
        },

        // Gets the number of days in the month of a date
        getDaysInMonth(date) {
            return moment(date).daysInMonth();
        },

    }
};

export default dateHelper;
